import callApi from "../../api/axios";

export const getReferralPartners = ({ st, et, q, limit, offset, type }) => {
  switch (type) {
    case "date":
      return callApi({
        method: "GET",
        url: `partners?limit=${limit}&offset=${offset}&st=${st}&et=${et}&type=${type}`,
      });
    case "commissionSort":
      return callApi({
        method: "GET",
        url: `partners?limit=${limit}&offset=${offset}&st=${st}&et=${et}&type=${type}`,
      });
    case "partner":
      return callApi({
        method: "GET",
        url: `partners?limit=${limit}&offset=${offset}&q=${q}&type=${type}`,
      });
    default:
      return callApi({
        method: "GET",
        url: `partners?limit=${limit}&offset=${offset}&st=${st}&et=${et}&type=date`,
      });
  }
};

export const getReferralPartnerById = (id) => {
  return callApi({ method: "GET", url: `partners/${id}` });
};

export const removeReferralPartner = (id) => {
  return callApi({
    method: "DELETE",
    url: `partners/${id}`,
  });
};

export const updateReferralPartner = (payload) => {
  return callApi({
    method: "PUT",
    url: `partners/${payload._id}`,
    data: payload,
  });
};

export const searchPartner = (value) => {
  return callApi({
    method: "POST",
    url: "partners/search",
    data: { q: value },
  });
};

export const getPartnerTrackingStats = ({ id, st, et }) => {
  return callApi({
    method: "GET",
    url: `partners/${id}/tracking-stats?st=${st}&et=${et}`,
  });
};

export const getStatusEmailSentW9Form = (partnerId) => {
  return callApi({
    method: "GET",
    url: `partners/${partnerId}/get-status-email-w9-form`,
  });
};

export const sendEmailW9Form = (partnerId) => {
  return callApi({
    method: "GET",
    url: `partners/${partnerId}/email-w9-form`,
  });
};

export const checkProvidedW9Form = ({ partnerId, checked }) => {
  return callApi({
    method: "POST",
    url: `partners/${partnerId}/check-provided-w9-form`,
    data: { checked },
  });
};
